import { ActionType } from '../../types/action';

const listPermission = {
  resource: 'bank-lookup',
  action: ActionType.READ,
};
const createPermission = {
  resource: 'bank-lookup',
  action: ActionType.CREATE,
};
const updatePermission = {
  resource: 'bank-lookup',
  action: ActionType.UPDATE,
};
const deletePermission = {
  resource: 'bank-lookup',
  action: ActionType.DELETE,
};

export const BankLookup = {
  list: listPermission,
  create: createPermission,
  update: updatePermission,
  delete: deletePermission,
};
